//eslint-disable-next-line
import $ from './jquery/jquery-3.6.0.min.js';
import './treantjs/vendor/jquery.min.js'
import './css/custom.css';

import './treantjs/Treant.css';
var raphael = require('./treantjs/vendor/raphael.js');
var Treant = require('./treantjs');

import _ from './lodash/lodash';

import { createPopper } from '@popperjs/core';


Treant = window.Treant;
window.Raphael = raphael;

export default {
    /*eslint-disable-next-line*/
    install(Vue, options){
        Vue.mixin({created() {},});

        Vue.component('org-chart', {
            template:
            `<div>
                <b-button @click="toggleView">{{toggleName}}</b-button>
                <div v-if="reloadTree == false" id="tree-chart"></div>

                <div @blur="hidePopper" tabindex="-1" @click="hidePopper" ref="treeNodePopper" id="levelPopper" v-show="showPopper">
                    <div class="card contextCard">
                        <div class="contextButton bottomBorder" @click="contextAction('add')">
                            <i style="text-align: center;width: 1rem;" class="dropIcon me-1 fas fa-arrow-down"></i>
                            Add Child
                        </div>
                        <div class="contextButton bottomBorder" @click="contextAction('add-sibling')">
                            <i style="text-align: center;width: 1rem;" class="dropIcon me-1 fas fa-arrow-left"></i>
                            Add Sibling
                        </div>
                        <div class="contextButton bottomBorder" @click="contextAction('edit')">
                            <i style="text-align: center;width: 1rem;" class="dropIcon me-1 fas fa-pen"></i>
                            Rename
                        </div>
                        <div class="contextButton bottomBorder" @click="contextAction('delete')">
                            <i style="text-align: center;width: 1rem;" class="dropIcon me-1 fas fa-trash"></i>
                            Delete
                        </div>
                        <div class="contextButton contextClose">
                            <i style="text-align: center;width: 1rem;" class="dropIcon me-1 fas fa-times-circle"></i>
                            Close
                        </div>
                    </div>
                </div>
            </div>
            `,
            props:{
                level_data:{},
                allow_toggle:{
                    type: Boolean,
                    default: false,
                },
                has_context_menu:{
                    type: Boolean,
                    default: false,
                }
            },
            data: () => ({
                stacked: false,
                chart: null,
                chart_config: null,
                selected_id: null,
                node: null,
                reloadTree: false,

                //* ctx menu
                showPopper: false,
                popper_id: null,
                popper: null,
                right_click_id: null,
            }),
            computed:{
                toggleName(){
                    let name = 'Show Compressed View';
                    if(this.stacked){
                        name = 'Show Normal View'
                    }
                    return name;
                }
            },
            methods:{
                toggleView(){
                    this.stacked = !this.stacked
                    //this.chart.tree.destroy();
                    this.reloadTree = true;
                    this.$nextTick(()=>{
                        this.$nextTick(()=>{
                            this.reloadTree = false;
                            this.$nextTick(()=>{
                                this.initChart();
                            })
                        })
                    })
                },
                initChart(){
                    let levels_data = this.level_data;
                    let levels = {};

                    //*Create objects for parent
                    levels_data.forEach(level => {
                        let user = 'No Lead User';
                        if(level.lead_user.name != undefined){
                            user = level.lead_user.name;
                        }
                        

                        levels[level.id] = {
                            parent_id: level.parent_id,
                            text:{
                                name: level.name,
                                'data-id': level.id,
                                title: user,
                            },
                            HTMLid: 'treeNode-'+level.id,
                            stackChildren: this.stacked,
                        }
                    });


                    //*Create default config
                    let tree = [];
                    let config = {
                        container: '#tree-chart',
                        connectors:{
                            type: 'step',
                            style:{
                                'stroke-width': 2,
                            }
                        },
                        node:{
                            HTMLclass: 'levelNode'
                        },
                        nodeAlign: 'CENTER',
                        scrollbar: 'None'
                    };

                    //* Add config object as the first part of the tree array
                    tree.push(config);

                    //* Find root node
                    let parent = _.find(levels, {parent_id: 0});
                    tree.push(parent);


                    //* Loop though levels and add parent object to node
                    let level_keys = Object.keys(levels);
                    level_keys.forEach((key) => {
                        let p_id = levels[key].parent_id;
                        if(levels[key].parent_id != 0){
                            levels[key]['parent'] = levels[p_id];

                            //* Add css to nodes without users */
                            //levels[key]['HTMLclass'] = 'redMe';
                            //levels[key].text.title = "No users in level"
                            tree.push(levels[key]);
                        }
                    });


                    this.chart_config = tree;

                    //* Pass current context to onTreeCreated
                    let context = this;

                    this.chart = new Treant(this.chart_config, this.onTreeCreated(context), $);
                },
                onTreeCreated(context){
                    //todo: Set parent node as selected.
                    $('body').off('click', '.Treant .node').on('click', '.Treant .node', function(){
                        let node = $(this)[0].id;
                        context.node = $(this);

                        //* reset value for watcher 
                        context.selected_id = null;
                        
                        context.$nextTick(()=>{
                            let id = node.split('-');
                            id = id[1];
                            context.selected_id = id;
                        })
                    });

                    //* enable the right click menu if the prop is true;
                    if(this.has_context_menu){
                        //* set right click event listener on treant nodes
                        $('body').off('contextmenu', '.Treant .node').on('contextmenu', '.Treant .node', function(){
                            let node = $(this)[0].id;
                            context.node = $(this);
                            context.$nextTick(()=>{
                                context.handleRightClick(node)
                            })
                            return false;
                        });
                    }
                },

                handleRightClick(id){
                    this.right_click_id = id;
                    this.showPopper = true;
                    const node = document.querySelector('#'+id);
                    const popper = document.querySelector('#levelPopper');
                    this.$nextTick(()=>{
                        this.popper = createPopper(node, popper,{
                            placement: 'auto'
                        });
                        setTimeout(()=>{
                            if(this.$refs.treeNodePopper != undefined){
                                this.$refs.treeNodePopper.focus();
                            }
                        }, 250);
                    })
                },
                hidePopper(){
                    if(this.popper != null){
                        this.popper.destroy();
                    }
                    this.showPopper = false;
                },
                contextAction(type){
                    let payload = {
                        id: this.right_click_id,
                        action_type: type,
                    }
                    this.$emit('contextAction', payload);
                }
            },
            watch:{
                selected_id(newValue){
                    if(newValue != null){
                        //if(newValue != oldValue){
                            let nodes = $('.Treant .node');
                            nodes.css({'border': '1px solid grey', 'background': 'white'});
                            this.$nextTick(()=>{
                                this.node.css({'background': 'rgb(188, 221, 255)'})
                            });
                            this.$emit('selectedNode', newValue);
                        //}
                        /*else if(this.allow_toggle){
                            alert('Setting null')
                            let nodes = $('.Treant .node');
                            nodes.css({'border': '1px solid grey', 'background': 'white'});
                            this.$emit('selectedNode', null);
                            this.selected_id = null;

                        }*/
                    }
                }
            },
            mounted(){
                window.inst = this;
                this.$nextTick(()=>{
                    //if(this.data != null){
                        this.initChart();
                    //}
                })
            },
            beforeDestroy(){
                window.inst = null;
            }
        })
    }
}
